import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Rate from '../../../../../shared/uielements/Engage/EngageButtons/RateButton';
import { hostNameAndPort } from '../../../../../shared/util/vars';
import { formatPriceAndCurrency } from '../../../../../shared/util/number';
import Axios from 'axios';

import {connect} from 'react-redux';
import { getTranslatedPhrase } from '../../../../../shared/util/lang';

class WallProperty extends Component {
    state = {
        realestateNotFound: true,
        featuredImage: '',
        title: '',
        reviews: [],
    }

    componentDidMount() {
        let b = this.props.realestateId;
        if (!b) {
            this.setState({ realestateNotFound: true });
            return;
        }
        let url = `${hostNameAndPort}/api/realestate/${b}`;
        Axios(url)
        .then(result => {
            let {data} = result;
            if (!data.error) {          
                data.item.creationDate = (new Date(data.item.creationDate)).toDateString();
                //data.item.realestateContent = (data.item.realestateContent).split('\n');
                data.item.realestateNotFound = false;
                this.setState(data.item);
                let _wallAction;
                switch (this.props.activityType) {
                    case 'review':
                    _wallAction = 'rated a property';
                    break;
                    case 'like':
                    _wallAction = 'liked a property';
                    break;
                    case 'post':
                    _wallAction = 'posted a property';
                    break;
                    case 'share':
                    _wallAction = 'shared a property';
                    break;
                    default: 
                    break;
                }
                this.props.onItemLoaded({
                    itemFailedLoading: false,
                    wallAction: _wallAction,
                });
            }
            else {
                this.props.onItemLoaded({ itemFailedLoading: true });
            }
        })
        .catch(err => {
            //console.log('Network error');
            this.props.onItemLoaded({ itemFailedLoading: true });
        });
    }

    render () {
        if (this.state.realestateNotFound) {
            return '';
        }
        let propertySlug = `/realestate/${this.state.category}/${this.state.slug}`;
        return (
            <div className="WallProduct">
                <Link to={propertySlug}>
                    <img src={this.state.featuredImage} alt={this.state.title} />
                </Link>

                <div className="WallProductDetails">
                    <div className="left">
                        <h4>{this.state.title}</h4>
                        <p className="WallProductPrice">{formatPriceAndCurrency(this.state.price,this.state.currency,',',(this.state.rentOrSell==='rent')?getTranslatedPhrase(this.props.userLanguage,'MONTH'):'')}</p>
                        <div className="WallpropertyRating"> 
                            <Rate noStars={this.state.averageRating} noReviews={this.state.reviews.length} />
                        </div>
                    </div>

                    <div className="right">
                    <Link to={propertySlug}>{getTranslatedPhrase(this.props.userLanguage,'See Details')}</Link>
                    </div>

                    <div className="clb" />
                </div>
            </div>
        );
    }
}


const mapStateToWallPropertyProps = (
    state,
    props
) => {
    return {
        userLanguage: state.userLanguage,
    };
};

export default connect(mapStateToWallPropertyProps, null)(WallProperty);
